export const PRESETS_SET = 'PRESETS_SET';
export const presetsSet = (data) => ({ type: PRESETS_SET, payload: data });

export const PRESETS_UPDATE_PRESET = 'PRESETS_UPDATE_PRESET';
export const presetsUpdatePreset = (data) => ({ type: PRESETS_UPDATE_PRESET, payload: data });
